import type { QuestionnaireStore } from "../Store";
import type { QuestionnaireApi } from "@/Modules/Models/Api/Questionnaire";
import type { Questionnaire } from "@/Modules/Models/Domain/Questionnaire";
import { QuestionnaireType } from "@/Modules/Models/Domain/Questionnaire";

import QuestionnaireApiToQuestionnaireTransformer from "@/Modules/Transformers/Questionaire/QuestionnaireApiToQuestionnaire";
import QuestionairesApiConnector from "@/Services/TherapyApi/Questionnaires";

import { danger } from "@/Utils/Debug";

class FetchAvailableQuestionnairesActionHandler {
  constructor(
    private readonly questionnaireStore: QuestionnaireStore,
    private readonly questionairesApiConnector = new QuestionairesApiConnector(),
    private readonly questionnaireApiToQuestionnaireTransformer = new QuestionnaireApiToQuestionnaireTransformer()
  ) {}

  public async handle(): Promise<void> {
    this.questionnaireStore.isLoading = true;
    try {
      const questionnaireApiResponse = await this.questionairesApiConnector.getAll({
        page_size: 1000,
      });

      const questionnaires = this.transformQuestionnairesApiToQuestionnaires(questionnaireApiResponse.body);

      this.questionnaireStore.allQuestionnaires = questionnaires;
      this.questionnaireStore.questionnaires = this.filterQuestionnaires(questionnaires);
    } catch (err: unknown) {
      danger(err);
    } finally {
      this.questionnaireStore.isLoading = false;
    }
  }

  private transformQuestionnairesApiToQuestionnaires(questionnairesApi: QuestionnaireApi[]): Questionnaire[] {
    const questionnaires: Questionnaire[] = questionnairesApi.map((questionnaireApi: QuestionnaireApi) => {
      return this.questionnaireApiToQuestionnaireTransformer.transform(questionnaireApi);
    });

    return questionnaires;
  }

  private filterQuestionnaires(questionnaires: Questionnaire[]): Questionnaire[] {
    const allowedQuestionnaireTypes = [QuestionnaireType.THERAPIST_ABOUT_THERAPYSIDE];

    const filteredQuestionnaires = questionnaires.filter((questionnaire) =>
      allowedQuestionnaireTypes.includes(questionnaire.type)
    );

    return filteredQuestionnaires;
  }
}

export default FetchAvailableQuestionnairesActionHandler;
